import { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import { FontFamily } from "assets";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import InputField from "components/Input";
import SystemServices from "services/System";
import DatePicker from "components/DatePicker";
import VendorServices from "services/Vendor";
import BankServices from "services/Bank";
import FinanceServices from "services/Finance";
import { useAuth } from "context/UseContext";
import { allowedRolesForCash } from "utils";

function UpdateTT() {

    const navigate = useNavigate();
    const { user } = useAuth();
    const { id } = useParams();

    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const [loading, setLoading] = useState(false);

    // *For Handle Date
    const [ttDate, setTtDate] = useState(new Date());

    // *For Vendor Dropdown
    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState(null);

    // *For Currencies
    const [currencies, setCurrencies] = useState([]);
    const [exchangeRate, setExchangeRate] = useState();

    // *For Rates
    const [ttCharges, setTtCharges] = useState(0);
    const [vatCharges, setVatCharges] = useState(0);
    const [fcyAmount, setFcyAmount] = useState(0);
    const [lcyAmount, setLcyAmount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);

    const [ttDetail, setTtDetail] = useState()

    // *For Payment Method
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
    const [damageAccounts, setDamageAccounts] = useState([]);
    const [vendorControlAccounts, setVendorControlAccounts] = useState([]);


    const [selectedVia, setSelectedVia] = useState(null)

    // *For Bank Account
    const [bankAccounts, _setBankAccounts] = useState([]);
    const [_cashierAccounts, setCashierAccounts] = useState([]);
    const [_selectedAccount, setSelectedAccount] = useState(null);
    const [bankAccountsGuc, setBankAccountsGuc] = useState([]);
    const [bankAccountsGws, setBankAccountsGws] = useState([]);
    const [selectedBankAccount, setSelectedBankAccount] = useState(null);

    const getTtDetailAccountId = () => {
        const rawId = ttDetail?.account_id ?? ttDetail?.account?.id;
        if (rawId === null || rawId === undefined || rawId === "") return null;
        return String(rawId);
    };

    const normalizePaymentMethodFromDetail = (paymentMedium) => {
        if (!paymentMedium) return null;

        // Backend might return either `bank` or the display labels.
        if (paymentMedium === "Bank GUC" || paymentMedium === "Bank GWS") {
            return { id: "bank", name: paymentMedium };
        }

        if (paymentMedium === "bank") {
            // Default; will be refined to GUC/GWS once we match account_id.
            return { id: "bank", name: "Bank GWS" };
        }

        if (paymentMedium === "cash") {
            return { id: "cash", name: "Cash" };
        }

        // Damages/Vendor Control are stored as their label.
        return { id: paymentMedium, name: paymentMedium };
    };

    // *For Handle Date
    const handleTtDate = (newDate) => {
        try {
            // eslint-disable-next-line eqeqeq
            if (newDate == 'Invalid Date') {
                setTtDate('invalid')
                return
            }
            setTtDate(new Date(newDate))
        } catch (error) {
            ErrorToaster(error)
        }
    }

    // *For Get Currencies
    const getCurrencies = async () => {
        try {
            let params = {
                detailed: true
            }
            const { data } = await SystemServices.getCurrencies(params)
            setCurrencies(data?.currencies)
        } catch (error) {
            ErrorToaster(error)
        }
    }

    // *For Vendor
    const getVendorDropdown = async () => {
        try {
            const { data } = await VendorServices.getVendorDropdown()
            setVendors(data?.vendors)
        } catch (error) {
            ErrorToaster(error)

        }
    }

    const getTTDetail = async () => {
        try {
            let params = {
                tt_id: id
            }
            const { data } = await VendorServices.getTTDetail(params)
            setTtDetail(data?.vendor)
            handleTtDate(data?.vendor?.tt_date)

            console.log(data);


        } catch (error) {
            ErrorToaster(error)
        }
    }

    // *For Get Payment Accounts
    // const getPaymentAccounts = async () => {
    //     try {
    //         let params = {
    //             page: 1,
    //             limit: 1000
    //         }
    //         const { data } = await FinanceServices.getPaymentAccounts(params)
    //         // *Filter only vehicle account
    //         const vehicleAcc = data?.cashierAccounts?.rows?.filter(e => e.unit === 'Shipping')
    //         // *1003 is the cashier role ID if the login user is a cashier then show only their account
    //         if (allowedRolesForCash.includes(user?.role_id)
    //         ) {
    //             const userId = user?.ref_id.split('-')[1]
    //             const filterCashier = vehicleAcc.filter(e => e.user_id == userId)
    //             setCashierAccounts(filterCashier)
    //         } else {
    //             setCashierAccounts(vehicleAcc)
    //         }
    //     } catch (error) {
    //         ErrorToaster(error)
    //     }
    // }

    const getPaymentAccounts = async () => {
        try {
            let params = {
                page: 1,
                limit: 1000,
            };
            const { data } = await FinanceServices.getVendorTTPaymentAccounts(params);

            // Cashier accounts for Shipping unit
            const vehicleAcc = data?.cashierAccounts?.rows?.filter(
                (e) => e.unit === "Shipping"
            );

            if (allowedRolesForCash.includes(user?.role_id)) {
                const userId = user?.ref_id.split("-")[1];
                const filterCashier = vehicleAcc.filter((e) => e.user_id == userId);
                setCashierAccounts(filterCashier);
            } else {
                setCashierAccounts(vehicleAcc);
            }

            // Damage wallet accounts: primary_series = 20091
            const damageAcc = data?.bankAccounts?.rows?.filter(
                (e) => Number(e.primary_series) === 20091
            );
            setDamageAccounts(damageAcc || []);

            // Vendor control accounts: primary_series = 50036
            const vendorControlAcc = data?.bankAccounts?.rows?.filter(
                (e) => Number(e.primary_series) === 50036
            );
            setVendorControlAccounts(vendorControlAcc || []);
        } catch (error) {
            ErrorToaster(error);
        }
    };


    // *For Get Banks
    const getBanks = async () => {
        try {
            let params = {
                page: 1,
                limit: 150,
                allow_active_only: 0,
            };
            const { data } = await BankServices.getBanks(params);
            const activeBanks = data?.banks?.rows.filter(bank => bank.is_active);
            const bankArray = [];
            activeBanks
                .filter((e) => e.currency)
                .forEach((e) => {
                    let obj = {
                        ...e,
                        account_code: e?.guc_account?.account_code,
                        name: e?.guc_account?.name,
                    };
                    bankArray.push(obj);
                });
            const gwsBank = bankArray.filter((bank) => bank?.gwc_account !== null);
            const gucBank = bankArray.filter((bank) => bank?.guc_account !== null);
            setBankAccountsGws(gwsBank)
            setBankAccountsGuc(gucBank);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Create TT
    const UpdateTT = async (formData) => {
        setLoading(true)
        try {
            let obj = {
                tt_id: id,
                vendor_id: selectedVendor?.id,
                via: selectedVia?.name ?? selectedVia,
                vendor_name: selectedVendor?.name,
                vendor_type: selectedVendor?.type,
                external_no: formData?.externalRef,
                fcy_amount: parseFloat(fcyAmount || 0).toFixed(2),
                ex_rate: exchangeRate,
                fcy_currency: selectedVendor?.currency,
                lcy_amount: parseFloat(lcyAmount || 0).toFixed(2),
                tt_charges: ttCharges,
                vat_charges: vatCharges,
                total_amount: (parseFloat(totalAmount) + parseFloat(ttCharges) + parseFloat(vatCharges)).toFixed(2),
                notes: formData?.note,
                payment_medium: selectedPaymentMethod?.id,
                tt_date: ttDate,
                account_name: selectedBankAccount?.name,
                account_id:
                    selectedBankAccount?.id
            }
            const { message } = await VendorServices.UpdateTT(obj)
            SuccessToaster(message)
            navigate('/tt-list')
        } catch (error) {
            ErrorToaster(error)
        } finally {
            setLoading(false)
        }
    }

    // *For Handle Select Vendor
    const handleSelectVendor = (data, rateOverride) => {
        try {
            const exRate =
                rateOverride ??
                currencies?.find((e) => e.currency === data?.currency)?.conversion_rate;
            console.log(data, 'data');
            setSelectedVendor(data)
            setValue('vendor', data)

            const resolvedRate = exRate ?? 0;
            setValue('ttRate', resolvedRate)
            setExchangeRate(resolvedRate)
        } catch (error) {
            ErrorToaster(error)
        }
    }

    // *For Handle Calculate
    const handleCalc = (value) => {
        try {
            const raw = String(value ?? "");
            const normalized = raw.replace(/,/g, ".");
            const fcyValue = parseFloat(normalized) || 0;
            const formattedFcy = Number(fcyValue.toFixed(2));
            const rate = parseFloat(exchangeRate) || 0;
            const aed = formattedFcy * rate;

            setFcyAmount(formattedFcy);
            setLcyAmount(aed);
            setTotalAmount(aed);
        } catch (error) {
            ErrorToaster(error)
        }
    }

    // *For Handle Payment Method
    const handlePaymentMethod = (data) => {
        try {
            setSelectedPaymentMethod(data)
            if (data?.id === 'bank') {
                setSelectedAccount(bankAccounts[0])
            } else {
                setSelectedAccount(null)
            }
        } catch (error) {
            ErrorToaster(error)
        }
    }

    useEffect(() => {
        if (exchangeRate) {
            handleCalc(fcyAmount)
        }
    }, [exchangeRate]);

    useEffect(() => {
        getVendorDropdown()
        getPaymentAccounts()
        getBanks()
        getCurrencies()
        getTTDetail()
    }, []);

    useEffect(() => {
        if (ttDetail) {
            setValue('externalRef', ttDetail?.external_no)
            setSelectedVendor(ttDetail?.vendor)
            setExchangeRate(ttDetail.ex_rate);
            handleSelectVendor(ttDetail?.vendor, ttDetail?.ex_rate)
            console.log(ttDetail?.fcy_amount);
            setValue('vendor', ttDetail?.vendor)
            let parsedFcyAmount = parseFloat(ttDetail?.fcy_amount);
            let parsedTtCharges = parseFloat(ttDetail?.tt_charges);
            let parsedVatCharges = parseFloat(ttDetail?.vat_charges);
            handleCalc(parsedFcyAmount);

            setValue("fcyAmount", parsedFcyAmount);
            setValue("ttCharges", parsedTtCharges);
            setValue("vatCharges", parsedVatCharges);
            setTtCharges(parsedTtCharges);
            setVatCharges(parsedVatCharges);

            const normalizedPaymentMethod = normalizePaymentMethodFromDetail(ttDetail?.payment_medium);
            setSelectedPaymentMethod(normalizedPaymentMethod);
            setValue('paymentMethod', normalizedPaymentMethod);

            // Restore Via selection (SelectField expects an object with `name`).
            if (ttDetail?.via) {
                const viaObj = typeof ttDetail.via === "string" ? { id: ttDetail.via, name: ttDetail.via } : ttDetail.via;
                setSelectedVia(viaObj);
                setValue('via', viaObj);
            }
            setValue('exchange rate', ttDetail.ex_rate)
            setValue('note', ttDetail?.notes || '');
        }

    }, [ttDetail])

    useEffect(() => {
        // Keep RHF state in sync with the Autocomplete selection so validation works.
        if (selectedBankAccount?.id) {
            setValue('bank', selectedBankAccount, { shouldValidate: true, shouldDirty: true });
        } else {
            setValue('bank', null, { shouldValidate: true, shouldDirty: true });
        }
    }, [selectedBankAccount, setValue]);

    useEffect(() => {
        if (!ttDetail) return;
        if (selectedBankAccount) return;

        const accountId = getTtDetailAccountId();
        if (!accountId) return;

        const paymentMedium = ttDetail?.payment_medium;

        // Bank: infer whether it belongs to GUC or GWS by matching account_id.
        if (paymentMedium === "bank" || paymentMedium === "Bank GUC" || paymentMedium === "Bank GWS") {
            const matchedGuc = bankAccountsGuc.find((b) => String(b?.guc_account?.id) === accountId);
            if (matchedGuc) {
                setSelectedPaymentMethod({ id: "bank", name: "Bank GUC" });
                setValue('paymentMethod', { id: "bank", name: "Bank GUC" });
                setSelectedBankAccount({
                    id: matchedGuc?.guc_account?.id,
                    name: matchedGuc?.guc_account?.name,
                    totalBal: matchedGuc?.gucBal ?? 0,
                    account_code: matchedGuc?.guc_account?.account_code,
                });
                return;
            }

            const matchedGws = bankAccountsGws.find((b) => String(b?.gwc_account?.id) === accountId);
            if (matchedGws) {
                setSelectedPaymentMethod({ id: "bank", name: "Bank GWS" });
                setValue('paymentMethod', { id: "bank", name: "Bank GWS" });
                setSelectedBankAccount({
                    id: matchedGws?.gwc_account?.id,
                    name: matchedGws?.gwc_account?.name,
                    totalBal: matchedGws?.gwcBal ?? 0,
                    account_code: matchedGws?.gwc_account?.account_code,
                });
                return;
            }
        }

        if (paymentMedium === "Damages Claimed - Wallet") {
            const matchedDamage = damageAccounts.find((a) => String(a?.id) === accountId);
            if (matchedDamage) {
                setSelectedBankAccount({
                    id: matchedDamage?.id,
                    name: matchedDamage?.name,
                    totalBal: matchedDamage?.totalBal ?? matchedDamage?.total_balance ?? 0,
                    account_code: matchedDamage?.account_code,
                });
                return;
            }
        }

        if (paymentMedium === "Vendor Control Account") {
            const matchedVendor = vendorControlAccounts.find((a) => String(a?.id) === accountId);
            if (matchedVendor) {
                setSelectedBankAccount({
                    id: matchedVendor?.id,
                    name: matchedVendor?.name,
                    totalBal: matchedVendor?.totalBal ?? 0,
                    account_code: matchedVendor?.account_code,
                });
                return;
            }
        }

        // Fallback: set from server-provided account object if available.
        if (ttDetail?.account?.id && ttDetail?.account?.name) {
            setSelectedBankAccount({
                id: ttDetail.account.id,
                name: ttDetail.account.name,
                totalBal: ttDetail.account.totalBal ?? ttDetail.account.total_balance ?? 0,
                account_code: ttDetail.account.account_code,
            });
        }
    }, [ttDetail, bankAccountsGuc, bankAccountsGws, damageAccounts, vendorControlAccounts, selectedBankAccount, setValue]);


    return (
        <Box sx={{ m: 4, p: 5, bgcolor: Colors.white, borderRadius: 3, boxShadow: '0px 8px 18px 0px #9B9B9B1A' }}>

            <Box component="form" onSubmit={handleSubmit(UpdateTT)}>
                <Typography variant="h5" sx={{ color: Colors.charcoalGrey, fontFamily: FontFamily.NunitoRegular, mb: 3 }}>
                    Add TT
                </Typography>
                <Grid container spacing={2} alignItems={'center'}>
                    <Grid item sm={4}>
                        <DatePicker
                            label={'Date'}
                            value={ttDate}
                            onChange={(date) => handleTtDate(date)}
                        />
                    </Grid>
                    <Grid item sm={4}>
                        <InputField
                            label={"External Ref No"}
                            placeholder={"External Ref No"}
                            error={errors?.externalRef?.message}
                            register={register("externalRef", {
                                required: "Please enter external ref.",
                            })}
                        />
                    </Grid>
                    <Grid item sm={4}>
                        <SelectField
                            label={'Vendor'}
                            options={vendors}
                            selected={selectedVendor}
                            onSelect={(value) => handleSelectVendor(value)}
                            error={errors?.vendor?.message}
                            register={register("vendor", {
                                required: 'Please select vendor.',
                            })}
                        />
                    </Grid>
                    <Grid item={12} sm={4}>
                        <SelectField
                            label={"Via"}
                            options={[{ id: 'LULU INTL. EXCHANGE', name: 'LULU INTL. EXCHANGE' }, { id: 'AL ANSARI  EXCHANGE', name: 'AL ANSARI  EXCHANGE' }, { id: 'AL FARDAN EXCHANGE', name: 'AL FARDAN EXCHANGE' }, { id: 'AL ROSTAMANI EXCHANGE', name: 'AL ROSTAMANI EXCHANGE' }, { id: 'WALL STREET EXG', name: 'WALL STREET EXG' }]}
                            selected={selectedVia}
                            onSelect={(value) => {
                                setSelectedVia(value);
                            }}
                            error={errors?.via?.message}
                            register={register("via", {
                                required: "Please select via.",
                            })}

                        />
                    </Grid>
                    <Grid item sm={4}>
                        <InputField
                            type={'text'}
                            label={selectedVendor?.currency === 'aed' ? 'FCY Amount (AED)' : 'FCY Amount ($)'}
                            placeholder={selectedVendor?.currency === 'aed' ? 'FCY Amount (AED)' : 'FCY Amount ($)'}
                            inputProps={{ inputMode: 'decimal' }}
                            register={register("fcyAmount", {
                                onChange: (e) => (e.target.value ? handleCalc(e.target.value) : handleCalc(0)),
                                onBlur: (e) => {
                                    const raw = String(e?.target?.value ?? "").trim();
                                    if (!raw) return;
                                    const n = parseFloat(raw.replace(/,/g, "."));
                                    if (Number.isNaN(n)) return;
                                    const fixed = n.toFixed(2);
                                    setValue('fcyAmount', fixed);
                                    handleCalc(fixed);
                                },
                            })}
                        />
                    </Grid>
                    <Grid item sm={4}>
                        <InputField
                            disabled={true}
                            label={"LCY Amount (AED)"}
                            placeholder={"LCY Amount (AED)"}
                            value={parseFloat(lcyAmount).toFixed(2)}
                        />
                    </Grid>
                    <Grid item sm={4}>
                        <InputField
                            label={'TT Rate (AED)'}
                            placeholder={'TT Rate (AED)'}
                            InputProps={{ inputProps: { min: 0 } }}
                            register={register("ttRate", {
                                onChange: e => e.target.value ? setExchangeRate(e.target.value) : exchangeRate
                            })}
                        />
                    </Grid>
                    <Grid item sm={4}>
                        <InputField
                            label={'TT and Bank Charges (AED)'}
                            placeholder={'TT and Bank Charges (AED)'}
                            error={errors?.ttCharges?.message}
                            register={register("ttCharges", {
                                required: "Please enter tt bank charges.",
                                onChange: e => e.target.value ? setTtCharges(e.target.value) : ttCharges
                            })}
                        />
                    </Grid>
                    <Grid item sm={4}>
                        <InputField
                            label={'VAT on Bank Charges (AED)'}
                            placeholder={'VAT on Bank Charges '}
                            error={errors?.vatCharges?.message}
                            register={register("vatCharges", {
                                required: "Please enter vat charges.",
                                onChange: e => e.target.value ? setVatCharges(e.target.value) : vatCharges
                            })}
                        />
                    </Grid>
                    <Grid item sm={4}>
                        <SelectField
                            label={'Payment Method'}
                            options={[
                                ...(allowedRolesForCash.includes(user?.role_id)
                                    ? [
                                        {
                                            "id": "cash",
                                            "name": "Cash",
                                        },
                                    ]
                                    : []),
                                {
                                    id: 'bank',
                                    name: 'Bank GWS',
                                },
                                {
                                    id: 'bank',
                                    name: 'Bank GUC',
                                },
                                {
                                    id: "Damages Claimed - Wallet",
                                    name: "Damages Claimed - Wallet",
                                },
                                {
                                    id: "Vendor Control Account",
                                    name: "Vendor Control Account",
                                },
                            ]}
                            selected={selectedPaymentMethod}
                            onSelect={(value) => handlePaymentMethod(value)}
                            error={errors?.paymentMethod?.message}
                            register={register("paymentMethod", {
                                required: 'Please select payment method.',
                            })}
                        />
                    </Grid>
                    {/* <Grid item xs={12} sm={12}> */}
                                {selectedPaymentMethod?.id === "bank" ||
                                  selectedPaymentMethod?.name === "Bank GUC" ? (
                                  <>
                                    <Grid item sm={4}>
                                      <SelectField
                                        size="small"
                                        label="Bank Account"
                                        options={
                                          selectedPaymentMethod?.name === "Bank GUC"
                                            ? bankAccountsGuc.map((account) => ({
                                              id: account?.guc_account?.id,
                                              name: account?.guc_account?.name,
                                              totalBal: account?.gucBal,
                                              account_code: account?.guc_account?.account_code,
                                            }))
                                            : bankAccountsGws.map((account) => ({
                                              id: account?.gwc_account?.id,
                                              name: account?.gwc_account?.name,
                                              totalBal: account?.gwcBal,
                                              account_code: account?.gwc_account?.account_code,
                                            }))
                                        }
                                        selected={selectedBankAccount}
                                        onSelect={(value) => {
                                          if (!value?.id) {
                                            ErrorToaster(
                                              "DO NOT CLOSE THE TAB REPORT TO IT FOR REVIEW."
                                            );
                                          } else {
                                            setSelectedBankAccount(value);
                                                                                        setValue('bank', value, { shouldValidate: true, shouldDirty: true });
                                          }
                                        }}
                                        error={errors?.bank?.message}
                                        register={register("bank", {
                                                                                    validate: () => {
                                                                                        const needsBank =
                                                                                            selectedPaymentMethod?.id === "bank" ||
                                                                                            selectedPaymentMethod?.name === "Bank GUC";
                                                                                        if (!needsBank) return true;
                                                                                        return (
                                                                                            !!selectedBankAccount?.id ||
                                                                                            "Please select bank account."
                                                                                        );
                                                                                    },
                                        })}
                                      />
                                    </Grid>
                    
                                    {selectedBankAccount && (
                                      <Grid item xs={12} md={4}>
                                        <InputField
                                          label={"Bank balance "}
                                          disabled={true}
                                          value={parseFloat(selectedBankAccount?.totalBal).toFixed(
                                            2
                                          )}
                                          size="small"
                                        />
                                      </Grid>
                                    )}
                                  </>
                                ) : selectedPaymentMethod?.name === "Damages Claimed - Wallet" ? (
                                  <>
                                    <Grid item xs={12} sm={4}>
                                      <SelectField
                                        size="small"
                                        label="Damage Account"
                                        options={damageAccounts.map((account) => ({
                                          id: account.id,
                                          name: account.name,
                                          totalBal:
                                            account.totalBal ??
                                            account.total_balance ??
                                            0,
                                          account_code: account.account_code,
                                        }))}
                                        selected={selectedBankAccount}
                                        onSelect={(value) => {
                                          if (!value?.id) {
                                            ErrorToaster(
                                              "DO NOT CLOSE THE TAB REPORT TO IT FOR REVIEW."
                                            );
                                          } else {
                                            setSelectedBankAccount(value);
                                                                                        setValue('bank', value, { shouldValidate: true, shouldDirty: true });
                                          }
                                        }}
                                        error={errors?.bank?.message}
                                        register={register("bank", {
                                                                                    validate: () => {
                                                                                        const needsDamage =
                                                                                            selectedPaymentMethod?.name ===
                                                                                            "Damages Claimed - Wallet";
                                                                                        if (!needsDamage) return true;
                                                                                        return (
                                                                                            !!selectedBankAccount?.id ||
                                                                                            "Please select damage account."
                                                                                        );
                                                                                    },
                                        })}
                                      />
                                    </Grid>
                    
                                    {selectedBankAccount && (
                                      <Grid item xs={12} md={4}>
                                        <InputField
                                          label={"Bank balance "}
                                          disabled={true}
                                          value={parseFloat(selectedBankAccount?.totalBal).toFixed(
                                            2
                                          )}
                                          size="small"
                                        />
                                      </Grid>
                                    )}
                                  </>
                                ) : selectedPaymentMethod?.name === "Vendor Control Account" ? (
                                  <>
                                    <Grid item xs={12} sm={4}>
                                      <SelectField
                                        size="small"
                                        label="Vendor Account"
                                        options={vendorControlAccounts.map((account) => ({
                                          id: account.id,
                                          name: account.name,
                                          totalBal: account.totalBal ?? 0,
                                          account_code: account.account_code,
                                        }))}
                                        selected={selectedBankAccount}
                                        onSelect={(value) => {
                                          if (!value?.id) {
                                            ErrorToaster(
                                              "DO NOT CLOSE THE TAB REPORT TO IT FOR REVIEW."
                                            );
                                          } else {
                                            setSelectedBankAccount(value);
                                                                                        setValue('bank', value, { shouldValidate: true, shouldDirty: true });
                                          }
                                        }}
                                        error={errors?.bank?.message}
                                        register={register("bank", {
                                                                                    validate: () => {
                                                                                        const needsVendor =
                                                                                            selectedPaymentMethod?.name ===
                                                                                            "Vendor Control Account";
                                                                                        if (!needsVendor) return true;
                                                                                        return (
                                                                                            !!selectedBankAccount?.id ||
                                                                                            "Please select vendor account."
                                                                                        );
                                                                                    },
                                        })}
                                      />
                                    </Grid>
                    
                                    {selectedBankAccount && (
                                      <Grid item xs={12} md={4}>
                                        <InputField
                                          label={"Bank balance "}
                                          disabled={true}
                                          value={parseFloat(selectedBankAccount?.totalBal).toFixed(
                                            2
                                          )}
                                          size="small"
                                        />
                                      </Grid>
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                              {/* </Grid> */}
                    {/* <Grid item sm={4}>
                        {selectedPaymentMethod?.id === 'bank' || selectedPaymentMethod?.name === 'Bank GUC' ? (
                            <>
                                <Grid item xs={12} sm={12}>
                                    <SelectField
                                        size="small"
                                        label="Bank Account"
                                        options={
                                            selectedPaymentMethod?.name === 'Bank GUC'
                                                ? bankAccountsGuc.map((account) => ({
                                                    id: account?.guc_account?.id,
                                                    name: account?.guc_account?.name,
                                                    totalBal: account?.gucBal,
                                                    account_code: account?.guc_account?.account_code,
                                                }))
                                                : bankAccountsGws.map((account) => ({
                                                    id: account?.gwc_account?.id,
                                                    name: account?.gwc_account?.name,
                                                    totalBal: account?.gwcBal,
                                                    account_code: account?.gwc_account?.account_code,
                                                }))
                                        }
                                        selected={selectedBankAccount}
                                        onSelect={(value) => {
                                            if (!value?.id) {
                                                ErrorToaster('DO NOT CLOSE THE TAB REPORT TO IT FOR REVIEW.')
                                            } else {
                                                setSelectedBankAccount(value)
                                            }
                                        }}
                                        error={errors?.bank?.message}
                                        register={register('bank', {
                                            required:
                                                selectedPaymentMethod?.id === 'bank' || selectedPaymentMethod?.name === 'Bank GUC'
                                                    ? 'Please select bank account.'
                                                    : false,
                                        })}
                                    />
                                </Grid>

                                {selectedBankAccount && (
                                    <Grid item xs={12} md={12}>
                                        <InputField
                                            label={'Bank balance '}
                                            disabled={true}
                                            value={parseFloat(
                                                selectedBankAccount?.totalBal
                                            ).toFixed(2)}
                                            size='small'
                                        />
                                    </Grid>
                                )}
                            </>
                        ) : null}
                    </Grid> */}
                    <Grid item sm={4}>
                        <InputField
                            disabled={true}
                            label={'Total Amount'}
                            placeholder={'Total Amount'}
                            InputProps={{ inputProps: { min: 0 } }}
                            value={(parseFloat(totalAmount) + parseFloat(ttCharges || 0) + parseFloat(vatCharges || 0)).toFixed(2)}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <InputField
                            label={"Accountant Notes"}
                            placeholder={"Accountant Notes"}
                            multiline={true}
                            rows={2}
                            register={register("note")}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                        <Box sx={{ textAlign: 'right' }}>
                            <PrimaryButton
                                title="Cancel"
                                onClick={() => navigate('/tt-list')}
                                style={{ marginRight: '1rem' }}
                            />
                            <PrimaryButton
                                title="Update"
                                type="submit"
                                loading={loading}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>

        </Box>
    );
}

export default UpdateTT;